import React, { useState } from 'react';
import { PredictScoreNotice, PredictScoreNoticeArrow, PredictScoreNoticeModalTitle } from '@/svgs';
import { Modal } from 'antd';

interface PredictionScoreNoticeBarProps {
    content: string;
    title: string;
}

const NoticeBar: React.FC<PredictionScoreNoticeBarProps> = ({ content, title }) => {
    const [isModalOpen, setIsModalOpen] = useState(false);

    const handleCancel = () => {
        setIsModalOpen(false);
    };

    return (
        <>
            <div className="sub-tiku__predict-score-notice-bar" onClick={() => setIsModalOpen(true)}>
                <span>
                    <PredictScoreNotice />
                </span>
                <span className="sub-tiku__predict-score-notice-bar-title">{title}</span>
                <span>
                    <PredictScoreNoticeArrow />
                </span>
            </div>
            <Modal
                centered
                open={isModalOpen}
                onCancel={handleCancel}
                closeIcon={false}
                footer={null}
                title={null}
                width={488}
                styles={{ content: { padding: 0, borderRadius: 16 } }}
            >
                <div>
                    <div className="sub-tiku__predict-score-notice-modal-header">
                        <PredictScoreNoticeModalTitle />
                    </div>
                    <div className="sub-tiku__predict-score-notice-modal-content">
                        <span>{content}</span>
                    </div>
                    <div className="sub-tiku__predict-score-notice-modal-footer">
                        <div className="sub-tiku__predict-score-notice-modal-footer-btn" onClick={handleCancel}>
                            <span>我知道了</span>
                        </div>
                    </div>
                </div>
            </Modal>
        </>
    );
};

export default NoticeBar;
